/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-props-no-spreading */
import { Boundary, ImageLoader } from 'components/common';
import { useDocumentTitle, useScrollTop } from 'hooks';
import React, { useEffect, useMemo, useState } from 'react';
import { withRouter } from 'react-router-dom';
import firebase from 'firebase/firebase';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { query, collection, where } from 'firebase/firestore';
import { useCollection } from 'react-firebase-hooks/firestore';
import { useTranslation } from 'react-i18next';
import { displayDate } from 'helpers/utils';
import {
  usePagination,
  useTable,
  useSortBy,
  useGlobalFilter
} from 'react-table';
import { CustomTable } from '../../../components/common';

const Companies = () => {
  const { t } = useTranslation();
  useDocumentTitle('Admin - Uilpi');
  useScrollTop();
  useEffect(() => {
    document.body.classList.add('no-scroll');
    return () => {
      document.body.classList.remove('no-scroll');
    };
  });

  const [plans] = useCollection(query(collection(firebase.db, 'plans')), {
    snapshotListenOptions: { includeMetadataChanges: true }
  });

  const [companies, isLoadingCompanies] = useCollection(
    query(
      collection(firebase.db, 'users'),
      where('blocked', '==', 'false'),
      where('role', '==', 'COMPANY')
    ),
    {
      snapshotListenOptions: { includeMetadataChanges: true }
    }
  );

  const [dataCompanies, setDataCompanies] = useState([]);

  const dataFetch = (snapshot) => {
    const rows = [];
    snapshot.docs.map((company) =>
      rows.push({
        col1: (
          <div className="grid-admin item-img-wrapper">
            {company.data().avatar ? (
              <ImageLoader
                alt={company.data().fullname}
                className="item-img"
                src={company.data().avatar}
              />
            ) : (
              <Skeleton width={50} height={30} />
            )}
          </div>
        ),
        col2: company.data().fullname || <Skeleton width={50} />,
        col3: company.data().email || <Skeleton width={50} />,
        col4: company.id || <Skeleton width={30} />,
        col5: company.data().plan
          ? `${
              plans.docs.find((el) => el.id === company.data().plan.type).data()
                .name
            } (${displayDate(company.data().plan.expiration)})`
          : 'N/D' || <Skeleton width={30} />
      })
    );
    return rows;
  };

  useEffect(() => {
    if (!isLoadingCompanies && companies) {
      const result = dataFetch(companies);
      setDataCompanies(result);
    }
  }, [companies]);

  const columns = useMemo(
    () => [
      {
        Header: 'Avatar',
        accessor: 'col1',
        disableSortBy: true
      },
      {
        Header: t('signUpNameLabel'),
        accessor: 'col2'
      },
      {
        Header: 'Email',
        accessor: 'col3'
      },
      {
        Header: 'ID',
        accessor: 'col4'
      },
      {
        Header: `${t('userFieldPlan')} (${t('userFieldPlanExpiration')})`,
        accessor: 'col5'
      }
    ],
    []
  );

  const tableInstanceCompanies = useTable(
    { columns, data: dataCompanies, initialState: { pageSize: 10 } },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  return (
    <Boundary>
      <CustomTable
        tableInstance={tableInstanceCompanies}
        title={t('adminCompanies')}
      />
    </Boundary>
  );
};

export default withRouter(Companies);
